export const LOCATION_ALERT_REPORTS = 'location-alert-reports';
export const GET_ALERTS_COUNT = "getAlertsCount";
export const GET_ALERTS = "getAlerts";
export const MARK_ALERTS_AS_READ = 'markAlertsAsRead';
export const GET_ALL_CLIENT_USERS = 'getAllClientUsers'
export const GET_ALL_ACTIVE_EMPLOYEES = 'getAllActiveEmployees';

export const GET_ALL_ASSETS = 'getAllAssets';
export const GET_ALL_AVAILABLE_ASSETS = 'getAllAvailableAssets';
export const USERS = 'users';
export const REGISTER_ASSETS = 'registerAssets';
export const ASSETS = 'assets';
export const CUSTOMERS = 'customers';

// Label End points
export const ASSET_LABELS = 'asset-labels';
export const ASSET_LABELS_SEARCH = 'asset-labels/search';
export const ASSET_LABELS_ASSIGN = 'asset-labels/assign';
export const ASSET_LABELS_ASSETS = 'asset-labels/assets';
export const ASSET_LABELS_BULK_ADD = 'asset-labels/bulk-add-label';
export const ASSET_LABELS_BULK_REMOVE = 'asset-labels/bulk-remove-label';
export const ASSET_LABELS_BULK_STATUS = 'asset-labels/bulk-status';

//Task End points
export const GET_ALL_TASKS_BY_STATUS = 'getAllTasksByStatus';

// Trip endpoints
export const TRIPS = 'trips';
export const TRIP_ACTIVATE = 'activate';
export const TRIP_COMPLETE = 'complete';
export const TRIP_CANCEL = 'cancel';
export const TRIP_DEVICES = 'devices';
export const TRIP_ACTIVE_FOR_DEVICE = (deviceId) => `trips/device/${deviceId}/active-trip`;

// Notification preferences endpoint
export const NOTIFICATION_PREFERENCES = 'notification-preferences';

// WhatsApp alert recipients endpoint (GT06 tracker notifications)
export const WHATSAPP_RECIPIENTS = 'whatsapp-recipients';

// Notification queue endpoints
export const NOTIFICATIONS = 'notifications';
export const NOTIFICATIONS_BY_DEVICE = (deviceId) => `notifications/device/${deviceId}`;
export const NOTIFICATIONS_BY_TRIP = (tripId) => `notifications/trip/${tripId}`;
export const NOTIFICATION_RETRY = (id) => `notifications/${id}/retry`;

// Scheduled Group Unlock endpoints (GPS locks only)
export const SCHEDULED_UNLOCKS = 'scheduled-unlocks';
export const SCHEDULED_UNLOCK_DETAIL = (sessionId) => `scheduled-unlocks/${sessionId}`;
export const SCHEDULED_UNLOCK_CANCEL = (sessionId) => `scheduled-unlocks/${sessionId}/cancel`;